import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, PRIMARY_OUTLET, Router } from '@angular/router';
import { filter, map } from 'rxjs/operators';
import { BreadcrumbService } from '../../service/breadcrumb.service';

@Component({
  selector: 'app-breadcrumb',
  templateUrl: './breadcrumb.component.html',
  styleUrls: ['./breadcrumb.component.scss']
})
export class BreadcrumbComponent implements OnInit {

  public breadcrumbs;
  public title: string;
  public hideBreadCrumbs = false;
  public selectOneValues = [];
  public selectTwoValues = [];
  public selectThreeValues = [];

  constructor(private activatedRoute: ActivatedRoute,
              private router: Router, public breadCrumService: BreadcrumbService) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .pipe(map(() => this.activatedRoute))
      .pipe(map((route) => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }))
      .pipe(filter(route => route.outlet === PRIMARY_OUTLET))
      .subscribe(route => {
        const snapshot = this.router.routerState.snapshot;
        const title = route.snapshot.data.title;
        const hideBreadCrumbs = route.snapshot.data.hideBreadCrumbs;
        const parent = route.parent.snapshot.data.breadcrumb;
        const child = route.snapshot.data.breadcrumb;
        this.breadcrumbs = {};
        this.title = title;
        if (hideBreadCrumbs) {
          this.hideBreadCrumbs = hideBreadCrumbs;
        } else {
          this.hideBreadCrumbs = false;
        }
        this.breadcrumbs = {
          parentBreadcrumb: parent,
          childBreadcrumb: child
        };
      });
  }

  ngOnInit() {
    this.breadCrumService.getSelectValues();
    this.initialSelectSetup();
  }


  ngOnDestroy() { }

  // onFirstSelect(value){


  //   let valueSelected = this.breadCrumService.selectValues.filter(f=>f.ERP_ORGANIZATION_NAME === value.target.value)

  //   console.log(valueSelected.length, valueSelected.length ===1)
  //   if(valueSelected.length ===1 || value.target.value === 'All'){
  //     let a = this.breadCrumService.onFirstSelectChange(value.target.value);

  //     this.selectTwoValues = Array.from(new Set(a.map(x=>x.VENDOR_NAME)))
  //     this.selectThreeValues = Array.from(new Set(a.map(x=>x.VENDOR_SITE_CODE)))

  //   }


  // }

  // onSecondSelect(value){
  //   let valueSelected =  this.selectTwoValues .filter(f=>f === value.target.value)

  //   if(valueSelected.length ===1 || value.target.value === 'All'){
  //   let b = this.breadCrumService.onSecondSelectChange(value.target.value);
  //   this.selectThreeValues = Array.from(new Set(b.map(x=>x.VENDOR_SITE_CODE)))

  //   }
  // }


  // onThirdSelect(value){

  //   let valueSelected =  this.selectThreeValues .filter(f=>f === value.target.value)

  //   if(valueSelected.length ===1 || value.target.value === 'All'){
  //   let c=this.breadCrumService.onThirdSelectChange(value.target.value);
  //   }
  // }

  onFirstSelect(value) {
    const a = this.breadCrumService.onFirstSelectChange(value);

    this.selectTwoValues = Array.from(new Set(a.map(x => x.ACCOUNT_NAME)));
    this.selectThreeValues = Array.from(new Set(a.map(x => x.CUSTOMER_SITE)));
     // this.selectOneValues = Array.from(new Set(a.map(x=>x.ERP_ORGANIZATION_NAME)))
   }

   onSecondSelect(value) {
     const b = this.breadCrumService.onSecondSelectChange(value);
     this.selectThreeValues = Array.from(new Set(b.map(x => x.CUSTOMER_SITE)));
     // this.selectTwoValues = Array.from(new Set(b.map(x=>x.VENDOR_NAME)))
   }


   onThirdSelect(value) {
     const c = this.breadCrumService.onThirdSelectChange(value);
     // this.selectThreeValues = Array.from(new Set(c.map(x=>x.VENDOR_SITE_CODE)))
   }

  initialSelectSetup() {
    this.onFirstSelect(this.breadCrumService.select1);
    this.onSecondSelect(this.breadCrumService.select2);
    this.onThirdSelect(this.breadCrumService.select3);
  }

}
